import { render, staticRenderFns } from "./TableShow.vue?vue&type=template&id=2aeab125&scoped=true"
import script from "./TableShow.vue?vue&type=script&lang=js"
export * from "./TableShow.vue?vue&type=script&lang=js"
import style0 from "./TableShow.vue?vue&type=style&index=0&id=2aeab125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeab125",
  null
  
)

export default component.exports